import { Command } from '@/app/common/base/command'

export class SubmitMortgageCheckCommand extends Command {
    public async run(productActionId: string, formData: object) {
        await this.client.post('/api/mortgage-check/submit-form', { productActionId, formData })
    }
}
